export const BOARD_GAMES_PATH = '/board-games';
export const GAMES_PATH = '/games';
export const PLAYERS_PATH = '/players';

export const USERS_PATH = 'users';
